<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content class="caaks-dialog-text">{{ data.message }}</mat-dialog-content>
<mat-dialog-actions>
        <button mat-button color="secondary" [mat-dialog-close]="false">Annuler</button>
        <button mat-button color="primary" [mat-dialog-close]="true">Confirmer</button>
</mat-dialog-actions>